import { render } from "./App.vue?vue&type=template&id=8e8ebbe4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=8e8ebbe4&lang=css"

import exportComponent from "/home/lw8dl1214/actions-runner/_work/AIPR-Frontend/AIPR-Frontend/haleon-ar-detector/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__